__turbopack_context__.v({
  "container": "ModelContent-module__dydBsa__container",
  "fadeInItems": "ModelContent-module__dydBsa__fadeInItems",
  "spacing--lg": "ModelContent-module__dydBsa__spacing--lg",
  "spacing--md": "ModelContent-module__dydBsa__spacing--md",
  "spacing--sm": "ModelContent-module__dydBsa__spacing--sm",
  "spacing--xl": "ModelContent-module__dydBsa__spacing--xl",
  "spacing--xs": "ModelContent-module__dydBsa__spacing--xs",
  "spacing--xxl": "ModelContent-module__dydBsa__spacing--xxl",
  "spacing--xxs": "ModelContent-module__dydBsa__spacing--xxs",
  "spacing--xxxl": "ModelContent-module__dydBsa__spacing--xxxl",
  "spacing--xxxs": "ModelContent-module__dydBsa__spacing--xxxs",
});
